import { weatherTool } from './weather';
import { queryTool } from './files';
import { memoryTools, createMemoryTools } from './memory';
import { createVisualizationTools } from './visualization';

// Base tools that don't require any UI state
// Re-enabling queryTool now that it uses a server endpoint
export const baseTools = [
    // weatherTool,
    queryTool
];

// Export all tool creation functions
export { createMemoryTools, createVisualizationTools };

// Export all tools helper
export const getAllTools = () => [...baseTools, 
                        // ...createMemoryTools(), 
                        ...createVisualizationTools()];

// Export types
export type { MemoryState } from './memory';
export type { WeatherResult } from './weather';

// Export UI components
export { MemoryDisplay } from './memory/MemoryDisplay';
